<template>
  <div
    v-if="!isHrisProfile && !isTemplate"
    class="approvals-toggle"
  >
    <HideRbac :permissions="['editJobApprovalFlow']">
      <v-btn
        variant="outlined"
        min-width="48"
        width="48"
        class="approvals-icon"
        :active="currentTab === 'approvals'"
        @click="setCurrentTab('approvals')"
      >
        <v-icon icon="mdi-clipboard-check-outline" />
      </v-btn>
    </HideRbac>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import HideRbac from '@/components/rbac/HideRbac.vue';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import { useDocumentRightPanel } from '@/stores/document/rightPanel';

const { currentTab } = storeToRefs(useDocumentRightPanel());
const { setCurrentTab } = useDocumentRightPanel();

const { isHrisProfile, isTemplate } = storeToRefs(useCurrentJobProfile());
</script>

<style lang="less" scoped>
.approvals-icon {
  border-color: @stroke-default;

  :deep(.v-icon) {
    color: @icon-default;
  }
}
</style>
